import { Card, Collapse } from '@mui/material';
import { useState } from 'react';
import { CollapsibleCardHeader } from './components/CollapsibleCardHeader';
import { CollapsibleCardContent } from './components/CollapsibleCardContent';
import { CollapsibleCardProps, ActionButtonDefinition } from './types';

export type { CollapsibleCardProps, ActionButtonDefinition };

export const CollapsibleCard = ({
  title,
  titleTypographyVariant = 'titleMedium',
  actions,
  secondaryActions,
  avatar,
  badge,
  chips,
  endContent,
  twoColumn = false,
  collapsible = true,
  fullWidth = false,
  defaultClosed = false,
  isCompact = false,
  hideExpander = false,
  shouldShowPointer = false,
  children,
  cardActions,
  onToggle,
  onToggleOpen,
  rightComponent,
  cardActionRightComponent,
}: CollapsibleCardProps) => {
  const [open, setOpen] = useState<boolean>(!defaultClosed);

  return (
    <Card>
      <CollapsibleCardHeader
        title={title}
        titleTypographyVariant={titleTypographyVariant}
        actions={actions}
        secondaryActions={secondaryActions}
        avatar={avatar}
        badge={badge}
        chips={chips}
        collapsible={collapsible}
        endContent={endContent}
        isCompact={isCompact}
        hideExpander={hideExpander}
        open={open}
        setOpen={setOpen}
        onToggle={onToggle}
        onToggleOpen={onToggleOpen}
        shouldShowPointer={shouldShowPointer}
        rightComponent={rightComponent}
      />
      <Collapse in={!collapsible || open} timeout="auto" unmountOnExit>
        <CollapsibleCardContent
          twoColumn={twoColumn}
          fullWidth={fullWidth}
          cardActions={cardActions}
          isCompact={isCompact}
          cardActionRightComponent={cardActionRightComponent}
        >
          {children}
        </CollapsibleCardContent>
      </Collapse>
    </Card>
  );
};
